export const FETCH_UNITS = "FETCH_UNITS";
export const FETCH_UNITS_SUCCESS = "FETCH_UNITS_SUCCESS";
export const FETCH_UNITS_FAILURE = "FETCH_UNITS_FAILURE";
export const CREATE_UNIT = "CREATE_UNIT";
export const CREATE_UNIT_FAILURE = "CREATE_UNIT_FAILURE";
export const CREATE_UNIT_SUCCESS = "CREATE_UNIT_SUCCESS";